import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import keys from './keys';
import useMessage from '../../useMessage';

const useDeleteVideo = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, episodeId, videoId }) =>
      `/shows/${showId}/episodes/${episodeId}/promovideos/${videoId}`,
    method: 'DELETE',
    onSuccess: ({ showId, episodeId }) => {
      queryClient.invalidateQueries(keys.video({ showId, episodeId }));
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while deleting your video." />
        ),
      });
    },
  });

  return {
    deleteVideo: mutation.mutate,
    isDeleteVideoLoading: mutation.isLoading,
    isDeleteVideoError: mutation.isError,
    isDeleteVideoSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDeleteVideo;
